"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieryEndingAbilityHandler = exports.FieryEndingActorAbilityFactory = exports.FieryEndingAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AttributeType_1 = require("../../core/enums/AttributeType");
class FieryEndingAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.FieryEnding;
        this.__typeName = "FieryEnding";
    }
}
exports.FieryEndingAbilityArgs = FieryEndingAbilityArgs;
let FieryEndingActorAbilityFactory = class FieryEndingActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("FieryEnding", "Self", 0);
    }
};
FieryEndingActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("FieryEnding")
], FieryEndingActorAbilityFactory);
exports.FieryEndingActorAbilityFactory = FieryEndingActorAbilityFactory;
let FieryEndingAbilityHandler = class FieryEndingAbilityHandler {
    init(sequence, container, actorId) {
        container.registerEventHandlerScript(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), "ApplyEffects_OnKilled", {
            target: Target_1.Target.AllEnemies,
            effects: [
                {
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_1.MaxAttributeDecreaseEffectArgs(AttributeType_1.AttributeType.FireDamageImmunity, 10),
                    supernatural: true
                }
            ]
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY_ABILITY");
    }
};
FieryEndingAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.FieryEnding)
], FieryEndingAbilityHandler);
exports.FieryEndingAbilityHandler = FieryEndingAbilityHandler;
